export const defaultChatConfig = {
	sampleQuestions: [
		"Question 1",
		"Question 2",
	],
	summary:
		"Summary Text",
	description: [
		{
			text:
				"Text",
		},
		{
			bullet: "(1)",
			header: "Header 1",
			text:
				"Text 1",
		},
	],
	pageLength: 100,
};

export const defaultDocumentChatConfig = {
	sampleQuestions: [],
	summary: "Discuss this item's content and metadata",
	description: [],
	disclaimer: "AI can make mistakes. Consider checking important information.",
};

export const defaultMultiDocumentChatConfig = {
	sampleQuestions: [],
	summary: "Ask questions related to your search results. Answers for this session are sourced only from the <docCount> matching the following search criteria:",
	description: [],
	disclaimer: "Multi-document chat is experimental, please check all referenced sources."
};